import { EMPTY_VALUE } from 'stores/financeUtils';
import { toNumber } from 'utils/math';
import { getNumeric } from 'utils/object';

export const currencies = {
  USD: 'USD'
};

export const currencyFormat = (
  value: number | string | unknown,
  location?: string,
  currency?: string | unknown,
  compact?: boolean,
  digits?: number,
  minDigits = 0
) => {
  const numValue = getNumeric(value);
  if (numValue == undefined) return EMPTY_VALUE;
  if (digits === undefined) digits = 0;

  const factors = compact && compactFactors(numValue);
  const nValue = factors
    ? toNumber({ value: (numValue / factors.value).toFixed(digits) })
    : numValue;

  return (
    new Intl.NumberFormat(location || 'en-US', {
      style: 'currency',
      minimumFractionDigits: minDigits,
      maximumFractionDigits: digits,
      currency: currency && typeof currency == 'string' ? currency : currencies.USD
    }).format(nValue) + (factors ? factors.symbol : '')
  );
};

export const compactFactors = (value: number): { value: number; symbol: string } => {
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' }
  ];
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (value >= si[i].value) {
      break;
    }
  }
  return si[i];
};
